import {Suspense} from 'react';

import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {CompaniesListAll} from '../../components/companies-list-all';

import type {CompaniesListAllFragment} from './query';

type Props = {
	data: CompaniesListAllFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const CompaniesListAllContainer = ({data, fullWidth, insideToc}: Props) => {
	return (
		<Suspense>
			<CompaniesListAll
				options={{fullWidth, ...data?.contentBlockOptions}}
				info={{
					title: data?.info?.title ?? '',
					description:
						data?.info?.description && data?.info?.description.length > 0 ? (
							<PortableText value={data.info.description} />
						) : null,
				}}
				insideToc={insideToc}
			/>
		</Suspense>
	);
};
